import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const settingsPageReducer = (state = initialState.settingsPage, action) => {
  switch (action.type) {
    case actionTypes.settingsPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default settingsPageReducer;
